import React, { createContext, useContext, useRef, useState, useEffect } from "react";
import { mediaUrl } from "../lib/api";

const PlayerContext = createContext(null);
export const usePlayer = () => useContext(PlayerContext);

export function PlayerProvider({ children }) {
  const audioRef = useRef(null);
  const [track, setTrack] = useState(null); // {id, title, subtitle, production, cover, submissionId, extra}
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);

  const play = (t) => {
    if (track && t.id === track.id) {
      togglePlay();
      return;
    }
    setTrack(t);
    setProgress(0);
    const audio = audioRef.current;
    if (audio) {
      audio.src = mediaUrl(t.production, "audio");
      audio.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  };

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) { audio.play(); setPlaying(true); }
    else { audio.pause(); setPlaying(false); }
  };

  const seek = (pct) => {
    const audio = audioRef.current;
    if (audio && duration) { audio.currentTime = (pct / 100) * duration; }
  };

  const close = () => {
    const audio = audioRef.current;
    if (audio) { audio.pause(); audio.src = ""; }
    setTrack(null); setPlaying(false);
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const onTime = () => { setProgress(audio.duration ? (audio.currentTime / audio.duration) * 100 : 0); };
    const onMeta = () => setDuration(audio.duration || 0);
    const onEnd = () => setPlaying(false);
    audio.addEventListener("timeupdate", onTime);
    audio.addEventListener("loadedmetadata", onMeta);
    audio.addEventListener("ended", onEnd);
    return () => {
      audio.removeEventListener("timeupdate", onTime);
      audio.removeEventListener("loadedmetadata", onMeta);
      audio.removeEventListener("ended", onEnd);
    };
  }, []);

  return (
    <PlayerContext.Provider value={{ track, playing, progress, duration, play, togglePlay, seek, close }}>
      {children}
      <audio ref={audioRef} preload="none" />
    </PlayerContext.Provider>
  );
}
